import withOrderTreeData from './HOCs/withOrderTreeData'
import ReferralCommTreeInner from './ReferralCommTreeInner'
import ReferralCommTreeMobile from './ReferralCommTreeMobile'
const ReferralCommTree = (props) => {
	return (
		<div className=''>
			<div
				className='display overflow-y-hidden'
				style={{
					marginLeft: '8rem',
				}}
			>
				<div>
					<ReferralCommTreeInner {...props} />
				</div>
			</div>
			<div className='display-full mt-7'>
				<ReferralCommTreeMobile {...props} />
			</div>
		</div>
	)
}

export default withOrderTreeData(ReferralCommTree)
